import config from "../../config";
import $ from "jquery";
import Sidebar from "../../components/partials/Sidebar";
import Header from "../../components/partials/Header";
import Breadcrumb from "../../components/Breadcrumb";
import { useEffect, useState, useContext } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import "./style.css";
import moment from "moment";
import { millionComma, removeMillionComma } from "../../utils";
import {
  formatItemStatus,
  formatItemStatusPurchase,
  uomConversion,
  uomConversionUnit,
} from "../Sale/util";
import TruncatedTextWithTooltip from "../../components/TruncatedTextWithTooltip";
import { BiCreditCard, BiInfoCircle } from "react-icons/bi";
import PayDtlCard from "../../components/PayDtlCard";
import Tippy from "@tippyjs/react";
import { Modal } from "react-bootstrap";
import ItemViews from "../Master/Item/view";
import { ConfigContext } from "../../App";

function PurchaseReturnView(props) {
  const itemLevelNarration = useContext(ConfigContext)?.itemLevelNarration;
  const { id } = useParams();
  const location = useLocation();
  let filter = location.state?.currentFilter;
  let currentFilterState = location.state?.showFilter;
  let page = location.state?.currentPageNo;
  const [purchaseRtn, setPurchaseRtn] = useState(
    location.state?.purchaseRtn || [],
  );
  const [showItemModal, setShowItemModal] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const handleItemView = (data) => {
    setSelectedItemId(data);
    setShowItemModal(true);
  };
  const handleItemModalClose = () => {
    setShowItemModal(false);
    setSelectedItemId(null);
  };

  const [user, setUser] = useState({});
  let gAmt = Number(purchaseRtn.total_amt);
  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      setUser(JSON.parse(localStorage.getItem("inventory")).userData);
    }
  }, []);

  useEffect(
    function () {
      if (purchaseRtn.length == 0) {
        $.post(
          `${config.apiUrl}/purchaseOrderReturn/listPurchaseOrderReturn`,
          JSON.stringify({ po_rtn_id: id }),
          function (res) {
            setPurchaseRtn(res?.data?.list?.[0] || []);
          },
        );
      }
    },
    [purchaseRtn],
  );

  const challanDtl = {
    item_id: "",
    item_name: "",
    qty: "",
    rate: "",
    amount: "",
    disc: "",
    disc_amt: "",
    godown_id: "",
    avail_qty: null,
    alt_conv: "",
    base_uom: "",
    alt_uom: "",
    uom: "",
    alt_qty: "",
    alt_price: "",
    alt_rate: "",
    base_rate: "",
    narration: "",
  };
  const payDtl = [
    { mode: "Cash UGX", conv: 1, conv_amt: "", amt: "" },
    { mode: "USD", conv: 1, conv_amt: "", amt: "" },
    { mode: "Momo Pay", conv: 1, conv_amt: "", amt: "" },
    { mode: "Airtel Money", conv: 1, conv_amt: "", amt: "" },
  ];
  const initialState = {
    po_id: "",
    po_no: "",
    branch_id: "",
    buyer_id: "",
    buyer_name: "",
    po_date: "",
    trans_date: moment().format("YYYY-MM-DD"),
    reason: "",
    total_amt: "",
    item_dtl: [challanDtl],
    vehicle_no: "",
    payment_mode_id: 1,
    pay_dtl: payDtl,
  };

  const [formInputs, setFormInputs] = useState(initialState);
  useEffect(() => {
    if (purchaseRtn && Array.isArray(purchaseRtn.item_dtl)) {
      let prod = [...purchaseRtn.item_dtl];

      for (let i = 0; i < prod.length; i++) {
        let element = prod[i];
        if (element.uom == element.alt_uom) {
          let newProdDtl = {
            ...element,
            qty: element.alt_qty,
            alt_qty: element.qty,
          };
          prod[i] = newProdDtl;
        }
      }

      setFormInputs((prevState) => {
        let newState = {
          ...prevState,
          item_dtl: prod,
          pay_dtl: purchaseRtn?.pay_dtl
            ? JSON.parse(purchaseRtn.pay_dtl)
            : prevState.pay_dtl,
        };

        return newState;
      });
    }
  }, [purchaseRtn]);
  const [showPayDtl, setShowPayDtl] = useState(false);
  const handlePayDtl = () => {
    setShowPayDtl((prevState) => !prevState);
  };

  function getPaymentMode() {
    const paymentModes = formInputs.pay_dtl.filter(
      (pay) => pay.amt !== "" && pay.amt !== undefined && pay.amt > 0,
    );

    if (paymentModes.length === 0) {
      return "Cash UGX";
    } else if (paymentModes.length === 1) {
      return paymentModes[0].mode;
    } else {
      return "Multiple";
    }
  }

  console.log("purchaseRtn?.total_amountpurchaseRtn?.total_amount", gAmt);

  return (
    <>
      <div className="d-flex min-vh-100" style={{ background: "#DAE5FF" }}>
        <Sidebar />
        <div
          className="content m-1 p-2 position-relative"
          style={{ paddingBottom: "8rem" }}
        >
          <Header />
          <Breadcrumb path={["Purchase Return", "View Purchase Return"]} />

          <main className="bg-white rounded-2" id="pur_rtnAdd">
            <div className="container-fluid p-2 position-relative">
              <Link
                to="/purchase-return"
                className="position-absolute text-decoration-none small"
                style={{ top: "-1.5rem", right: "0" }}
                state={{
                  backToCurrent: page,
                  appliedFilter: filter,
                  filterDisplay: currentFilterState,
                }}
              >
                Go Back to List
              </Link>
              <form autoComplete="off">
                <div className="row gx-4 mb-2">
                  <div className="col-md">
                    <label htmlFor="pur_rtn_hdr_no">Purchase No</label>
                    <input
                      type="text"
                      className="form-control"
                      id="pur_rtn_hdr_no"
                      value={purchaseRtn.po_no}
                      disabled
                    />
                  </div>
                  <div className="col-md">
                    <label htmlFor="pur_rtn_hdr_no">Purchase Return No</label>
                    <input
                      type="text"
                      className="form-control"
                      id="pur_rtn_hdr_no"
                      value={purchaseRtn.po_rtn_no}
                      disabled
                    />
                  </div>

                  <div className="col-md">
                    <label htmlFor="pur_rtn_hdr_no">Supplier Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="pur_rtn_hdr_no"
                      value={purchaseRtn?.mst_buyer?.buyer_name || "N/A"}
                      disabled
                    />
                  </div>
                  {user.role_id != 3 && user.role_id != 4 && (
                    <div className="col-md-4">
                      <label htmlFor="branch_name">Branch Name</label>

                      <input
                        type="text"
                        className="form-control"
                        id="branch_name"
                        value={
                          props?.branchList?.find(
                            (x) => x?.value === purchaseRtn?.branch_id,
                          )?.label || "N/A"
                        }
                        disabled
                      />
                    </div>
                  )}

                  <div className="col-md">
                    <label htmlFor="dt_of_pur">Return Date</label>
                    <input
                      type="text"
                      className="form-control"
                      id="dt_of_pur"
                      value={moment(
                        purchaseRtn.trans_date,
                        "YYYY-MM-DD",
                      ).format("DD-MM-YY")}
                      disabled
                    />
                  </div>
                </div>

                <div className="row gx-4 mb-2">
                  <div className="col-md-3">
                    <label htmlFor="vehicle_no">Vehicle No</label>
                    <input
                      type="text"
                      className="form-control"
                      id="vehicle_no"
                      value={purchaseRtn?.vehicle_no}
                      disabled
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="payment_mode_id">Payment Mode</label>
                    <input
                      type="text"
                      className="form-control"
                      id="payment_mode_id"
                      value={
                        config?.paymentMode?.find(
                          (p) => p?.value == purchaseRtn?.payment_mode_id,
                        )?.label || "N/A"
                      }
                      // value={sale?.config?.paymentMode?.payment_mode_id || 'N/A'}
                      disabled
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="narration">Reason</label>
                    <textarea
                      type="text"
                      className="form-control"
                      id="narration"
                      value={purchaseRtn?.reason}
                      disabled
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <table
                      className="table mt-4 mb-5 rounded"
                      cellPadding="0"
                      cellSpacing="0"
                    >
                      <thead>
                        <tr>
                          <th>Item Name</th>
                          <th>UOM</th>
                          <th>Qty</th>
                          <th>Price</th>
                          <th>Amount</th>
                          <th>Godown</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {formInputs.item_dtl &&
                          formInputs.item_dtl.map((v, i) => (
                            <tr key={i}>
                              <td style={{ width: "400px" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    // justifyContent: "center",
                                    alignItems: "center",
                                    gap: "1px",
                                  }}
                                >
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={
                                      props?.itemLists?.find(
                                        (el) => el?.value === v.item_id,
                                      )?.label
                                    }
                                    disabled
                                  />
                                  {formInputs.item_dtl[i]?.item_id ? (
                                    <Tippy content="View Item">
                                      <div>
                                        {" "}
                                        <span
                                          className=""
                                          style={{ cursor: "pointer" }}
                                          onClick={() => handleItemView(v)}
                                        >
                                          <BiInfoCircle size={20} />
                                        </span>
                                      </div>
                                    </Tippy>
                                  ) : null}
                                </div>
                                {itemLevelNarration == 1 ? (
                                  <textarea
                                    type="text"
                                    className="form-control mt-1"
                                    name={"narration"}
                                    value={v?.narration}
                                    disabled
                                    maxLength={100}
                                  />
                                ) : null}
                              </td>
                              <td style={{ width: "100px" }}>
                                {v?.alt_uom != null && v?.alt_uom != "" && (
                                  <select
                                    id=""
                                    name="uom"
                                    value={v?.uom}
                                    disabled
                                    className="form-select"
                                  >
                                    {[v.base_uom, v.alt_uom].map((ele, ind) => (
                                      <option value={ele}>{ele}</option>
                                    ))}
                                  </select>
                                )}
                              </td>
                              <td style={{ width: "100px" }}>
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  value={v.qty}
                                  disabled
                                />
                                {v?.alt_uom != null && v?.alt_uom != "" && (
                                  <span
                                    className="text-right"
                                    style={{
                                      wordBreak: "break-all",
                                      fontSize: "10px",
                                    }}
                                  >
                                    <TruncatedTextWithTooltip
                                      text={uomConversionUnit(v)}
                                    />
                                  </span>
                                )}
                              </td>
                              <td style={{ width: "130px", maxWidth: "130px" }}>
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  // value={millionComma(v?.rate)}
                                  value={
                                    v?.uom == v?.alt_uom
                                      ? millionComma(v?.alt_price)
                                      : millionComma(v?.rate)
                                  }
                                  disabled
                                />
                                {/* {v?.alt_uom != null && v?.alt_uom != "" && (
                                  <span style={{ whiteSpace: "nowrap" }}>
                                    {`Per (`}
                                    <TruncatedTextWithTooltip text={v?.base_uom} />
                                    {`)`}
                                  </span>
                                )} */}
                                {v?.alt_uom != null &&
                                  v?.alt_uom !== "" &&
                                  (v?.uom == v?.alt_uom ? (
                                    <span
                                      style={{
                                        wordBreak: "break-all",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {`( ${v?.rate} Per `}
                                      <TruncatedTextWithTooltip
                                        text={uomConversion(v)}
                                      />
                                      {`)`}
                                    </span>
                                  ) : (
                                    <span
                                      style={{
                                        wordBreak: "break-all",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {`(${v?.alt_price} Per `}
                                      <TruncatedTextWithTooltip
                                        text={uomConversion(v)}
                                      />
                                      {`)`}
                                    </span>
                                  ))}
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  value={millionComma(v?.amount)}
                                  disabled
                                />
                              </td>
                              <td style={{ width: "160px" }}>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={
                                    props?.godown?.find(
                                      (el) => el?.value === v?.godown_id,
                                    )?.label || 0
                                  }
                                  disabled
                                />
                              </td>
                              <td style={{ width: "100px" }}>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={formatItemStatusPurchase(v)}
                                  disabled
                                />
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </form>
            </div>
            <div className="container-fluid mt-5">
              <div className="row">
                <div className="col-12 position-absolute bottom-0 start-0 end-0">
                  <div
                    className="row rounded px-2 py-3"
                    style={{ background: "#F4F7FE" }}
                  >
                    <div className="col-md-3">
                      <label htmlFor="sub_total">Total</label>
                      <input
                        type="text"
                        className="form-control text-end"
                        id="sub_total"
                        value={millionComma(gAmt)}
                        disabled
                      />
                    </div>
                    <div className="col d-flex mt-auto justify-content-end gap-2">
                      <div
                        style={{
                          border: "1px solid gray",
                          height: "37px",
                          minWidth: "200px",
                          borderRadius: "5px",
                          display: "flex",
                          alignItems: "center",
                          padding: "10px",
                        }}
                      >
                        <b className="me-2"> {getPaymentMode()} </b>:{" "}
                        {millionComma(gAmt)}
                      </div>
                      <BiCreditCard
                        size={32}
                        className="text-primary mt-1"
                        role="button"
                        onClick={handlePayDtl}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
      {showPayDtl && (
        <PayDtlCard
          cardMode="view"
          showPayDtl={showPayDtl}
          handlePayDtl={handlePayDtl}
          formInputs={formInputs}
          setFormInputs={setFormInputs}
          // grossTotal={removeMillionComma(gAmt)}
          grossTotal={gAmt}
        />
      )}
      <Modal
        show={showItemModal}
        onHide={handleItemModalClose}
        keyboard={false}
        backdrop="static"
        size="lg"
      >
        <ItemViews id={selectedItemId} hide={handleItemModalClose} />
      </Modal>
    </>
  );
}

export default PurchaseReturnView;
